import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { CONSTRUCTION_YEAR_LIMIT_SUPER } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/cabinConstants";
import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { CabinProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/CabinProduct";
import { isDefined } from "Utils/functions";
import React from "react";
import { AdditionalBuildingsCabinDetails } from "./AdditionalBuildingsCabinDetails";

export const cabinDetailsList = (
  product: CabinProduct,
  types: any,
  lang: string,
): ProductDetail[] => {
  const hideDetailsForOldCabin =
    product.constructionYear < CONSTRUCTION_YEAR_LIMIT_SUPER;

  return [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    { name: "constructionYear", value: product.constructionYear },
    {
      name: "firstRiskSum",
      value: <NumberValue value={product.firstRiskSum} type={VALUE_TYPE.NOK} />,
      hidden: !isDefined(product.firstRiskSum),
    },
    {
      name: "hasCrawlspace",
      value: <YesOrNo value={product?.crawlspace ?? false} />,
      hidden: hideDetailsForOldCabin,
    },
    {
      name: "pestsDamaged",
      value: <YesOrNo value={product?.previousFungusDamage ?? false} />,
      hidden: hideDetailsForOldCabin || product.crawlspace,
    },
    {
      name: "standard",
      value: types.cabinStandard[product.standard][lang],
    },
    {
      name: "hasElectricity",
      value: <YesOrNo value={product?.hasElectricity ?? false} />,
    },
    {
      name: "hasTapWater",
      value: <YesOrNo value={product?.hasTapWater ?? false} />,
    },
    {
      name: "hasRental",
      value: <YesOrNo value={product.hasRental ?? false} />,
      hidden: !isDefined(product.hasRental),
    },
    {
      name: "grossArea",
      value: (
        <NumberValue
          value={product.grossArea}
          type={VALUE_TYPE.SQUARE_METERS}
        />
      ),
    },
    {
      name: "livingArea",
      value: (
        <NumberValue
          value={product.livingFloorSpace}
          type={VALUE_TYPE.SQUARE_METERS}
        />
      ),
    },
    {
      name: "injuries",
      value:
        product.damageCountRecentYears === 2
          ? "2 eller flere"
          : product.damageCountRecentYears ?? 0,
    },
    {
      name: "injuryYear",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
    {
      name: "rentalTimeExceedsOneMonthAYear",
      value: "Nei",
      hidden: isDefined(product.hasRental),
    },
    {
      name: "historicalValue",
      value: <YesOrNo value={product.historicalValue ?? false} />,
      hidden: !isDefined(product.historicalValue),
    },
    {
      name: "otherBuildings",
      value: (
        <AdditionalBuildingsCabinDetails
          product={product}
          types={types}
          lang={lang}
        />
      ),
    },
    {
      name: "insuranceAdditionalBuilding",
      value:
        product.additionalBuildings.length > 0
          ? product.additionalBuildings[0].coverage
          : "??",
      hidden: product.additionalBuildings.length === 0,
    },
  ];
};
